import React, { useRef } from "react";
import { Dialog } from "@headlessui/react";
import { ContentBox } from "../structure/ContentBox";
import { ContentHeader } from "../structure/ContentHeader";
import { Button } from "../buttons/Button";

interface Props {
    title: string;
    description: string;
    buttonA: {
        label: string;
        onClick: () => void;
    };
    buttonB?: {
        label: string;
        onClick: () => void;
    };
    isOpen: boolean;
    setIsOpen: (v: boolean) => void;
}

export function BasicDialog({
    title,
    description,
    buttonA,
    buttonB,
    setIsOpen,
    isOpen
}: Props) {
    buttonA = buttonA ?? {
        label: "Ja",
        onClick: () => {
            return;
        }
    };

    buttonB = buttonB ?? {
        label: "Nej",
        onClick: () => {
            return;
        }
    };

    let completeButtonRef = useRef<HTMLButtonElement>(null);

    function handleAClick(e: React.MouseEvent<HTMLButtonElement>) {
        buttonA.onClick();
        setIsOpen(false);
    }

    function handleBClick() {
        buttonB!.onClick();
        setIsOpen(false);
    }

    return (
        <Dialog
            initialFocus={completeButtonRef}
            open={isOpen}
            onClose={() => setIsOpen(false)}
            className="relative z-50"
        >
            <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
            <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
                <Dialog.Panel>
                    <ContentBox className={"text-center max-w-[650px]"}>
                        <ContentHeader>{title}</ContentHeader>
                        <p className={"mb-40"}>{description}</p>
                        <div className={"flex justify-center space-x-16"}>
                            <Button
                                ref={completeButtonRef}
                                onClick={handleAClick}
                            >
                                {buttonA.label}
                            </Button>
                            <Button onClick={handleBClick}>
                                {buttonB.label}
                            </Button>
                        </div>
                    </ContentBox>
                </Dialog.Panel>
            </div>
        </Dialog>
    );
}
